<template>
    <span>
       {{text}}
    </span>
</template>

<script>
    export default {
        name: "FileServerText",
        props:{
            value: {
                type: String,
                default:function () {
                    return '' ;
                }
            }
        },
        watch:{

        },
        computed:{
             text(){

                let e =  this.fileServers.find((e)=>{
                      return e.code === this.selectValue
                 });

                 return e ? e.name:'';
;
             }
        },
        data(){
            return {
                selectValue:'',
                fileServers:[],
            }
        },
        created() {

            let vm = this;
            vm.$http.post(vm.$api.fileServer.list,vm.$qs.stringify({onPage:false})).then((resp)=>{
                    vm.fileServers = resp.data.data.fileServers;
                    vm.selectValue = vm.value;
            });

        }
    }
</script>

<style scoped>

</style>